const leanOperational = [
  {
    id: 1,
    img: "https://i.ibb.co/zT2XBwJX/Efficiency-Improvement-Drive-at-GEO-Steel.jpg",
    companyName: "Efficiency Improvement Drive at GEO Textile",
  },
  {
    id: 2,
    img: "https://i.ibb.co/DDkKv9vj/Gemba-Walk-Lean-Transformation-at-Confidence-Group.jpg",
    companyName: "Gemba Walk  & Lean Transformation at Confidence Group",
  },
  {
    id: 3,
    img: "https://i.ibb.co/MTQrcmw/Gemba-Walk-at-a-SPC-Pole-Manufacturing-Plan.jpg",
    companyName: "Gemba Walk at a SPC Pole Manufacturing Plant",
  },
  {
    id: 4,
    img: "https://i.ibb.co/PGyHch0y/Implementation-of-Lean-Manufacturing-Technique-at-FB-Footwear-Limited-01.jpg",
    companyName:
      "Implementation of Lean Manufacturing Technique at FB Footwear Limited",
  },
  {
    id: 5,
    img: "https://i.ibb.co/TDH2YwJV/Implementing-Lean-Manufacturing-System-at-Bay-Footwear-Ltd-01.jpg",
    companyName: "Implementing Lean Manufacturing System at Bay Footwear Ltd",
  },
  {
    id: 6,
    img: "https://i.ibb.co/39q1w23W/Kaizen-for-Operational-Excellence-at-Confidence-Cement-Limited-Chittagong.jpg",
    companyName:
      "Operational Excellence Consulting at Confidence Cement Limited, Chittagong",
  },
  {
    id: 7,
    img: "https://i.ibb.co/pjM3KTxV/Kaizen-Implementation-for-Operataional-Excellence-at-confidence-group.jpg",
    companyName:
      "Kaizen Implementation for Operational Excellence at confidence group",
  },
  {
    id: 8,
    img: "https://i.ibb.co/r2zWfy1S/Lean-Manufacturing-System-Kaizen-at-Craftsman-Footwear-Accessories-Ltd.jpg",
    companyName:
      "Lean Manufacturing System & Kaizen at Craftsman Footwear & Accessories Ltd",
  },
  {
    id: 9,
    img: "https://i.ibb.co/DDLm6tvX/Lean-Six-Sigma-Operational-Excellence-Consulting-at-Confidence-Power-Rangpur-Limited.jpg",
    companyName:
      "Lean Six Sigma & Operational Excellence Consulting at Confidence Power Rangpur Limited",
  },

  {
    id: 11,
    img: "https://i.ibb.co/jvRZgBvG/Lean-Six-Sigma-at-YKK-Zipper.jpg",
    companyName: "Lean Six Sigma at YKK Zipper",
  },
  {
    id: 12,
    img: "https://i.ibb.co/SwhzxBvR/Lean-Transfomation-Project-through-Kaizen-Concept-at-confidence-group.jpg",
    companyName:
      "Lean Transformation Project through Kaizen Concept at Confidence Group",
  },
  {
    id: 13,
    img: "https://i.ibb.co/CK80xNDq/Operational-Excellance-through-Lean-Six-Sigma.jpg",
    companyName:
      "Operational Excellence through Lean Six Sigma at GEO-BAG Manufacture of Confidence Group",
  },
  {
    id: 14,
    img: "https://i.ibb.co/8Ln8JTSB/Operational-Excellence-at-SMC-Tower.jpg",
    companyName: "Operational Excellence Consulting at SMC Plant",
  },
  {
    id: 15,
    img: "https://i.ibb.co/nNPnx579/Operational-Excellence-with-Akij-Ready-Mix-Concrete-Team.jpg",
    companyName: "Operational Excellence with Akij ReadyMix & Concrete Team",
  },
  {
    id: 16,
    img: "https://i.ibb.co/1tTZ6vhz/Productive-Day-with-JERA-Japan-Energy-for-New-Era-Meghnaghat-Power-Limited.jpg",
    companyName:
      "Productive Day with JERA (Japan Energy for New Era) Meghnaghat Power Limited",
  },
  {
    id: 17,
    img: "https://i.ibb.co/RkvRtzx6/Productivity-Improvement-Techniques-at-Asian-Group-Chittagong.jpg",
    companyName:
      "Productivity Improvement Techniques at Asian Group- Chittagong",
  },
  {
    id: 18,
    img: "https://i.ibb.co/9DHpGgk/Productivity-improvement-Consulting-at-MAZ-Group.jpg",
    companyName: "Productivity Improvement Consulting at MAZ Group",
  },

  {
    id: 20,
    img: "https://i.ibb.co/9HXLHW7Q/implementing-Operational-Excellence-in-the-steel-fabrication-industry.jpg",
    companyName:
      "Implementing Operational Excellence in the steel fabrication industry",
  },

  {
    id: 22,
    img: "https://i.ibb.co/r21qNKYw/Efficiency-Improvement-Consultancy-Project-at-Alim-Knit-Bd-Ltd-Mondol-Group.jpg",
    companyName:
      "Efficiency Improvement Consultancy Project at Alim Knit Bd Ltd-Mondol Group",
  },
  {
    id: 23,
    img: "https://i.ibb.co/b511DQZ4/Efficiency-Improvement-Consultancy-Session-at-DK-Group.jpg",
    companyName: "Efficiency Improvement Consultancy Session at DK Group",
  },
  {
    id: 24,
    img: "https://i.ibb.co/gMYJFnvg/Efficiency-Improvement-Drive-with-Participants-from-M-J-Group-and-Smart-Technology.jpg",
    companyName:
      "Efficiency Improvement Drive with Participants from M&J Group and Smart Technology",
  },
  {
    id: 25,
    img: "https://i.ibb.co/dw394GwG/Efficiency-Improvement-Consulting-at-Bestwool.jpg",
    companyName: "Efficiency Improvement Consulting at BestWool",
  },
  {
    id: 26,
    img: "https://i.ibb.co/nMmJMW3C/Efficiency-Improvements-Drive-and-Supervisory-Skill-Development-Session-at-Green-Smart-Shirt-Limited.jpg",
    companyName:
      "Efficiency Improvements Drive and Supervisory Skill Development Session at Green Smart Shirt Limited",
  },

  {
    id: 28,
    img: "https://i.ibb.co/F4wqYbcz/Lean-Six-sigma-Operational-Excellence-at-Akij-Shipping.jpg",
    companyName:
      "Lean Six sigma & Operational Excellence at Akij Shipping Lines",
  },

  {
    id: 29,
    img: "https://i.ibb.co/DPpzxdvK/Operational-Excellence-Team-in-Action-at-Mondol-Group.jpg",
    companyName: "Operational Excellence Training at Mondol Group",
  },
  {
    id: 10,
    img: "https://i.ibb.co/0VqtZLKW/Lean-Six-Sigma-Operational-Excellence-Consulting-session-with-The-ACME-Laboratories.jpg",
    companyName:
      "Lean Six Sigma & Operational Excellence Consulting session with The ACME Laboratories",
  },
  {
    id: 1,
    img: "https://i.ibb.co/b56TPP3d/A-highly-productive-day-with-the-Op-Ex-Team-of-Confidence-Group-at-their-Galvanizing-Plant.jpg",
    companyName:
      "A highly productive day with the OpEx Team of Confidence Group at their Galvanizing Plant",
  },

  {
    id: 6,
    img: "https://i.ibb.co/xSb85Fgx/Gemba-Walk-Training-at-Confidence-Group.jpg",
    companyName: "Gemba Walk Training at Confidence Group",
  },
  {
    id: 9,
    img: "https://i.ibb.co/GvNX8FvJ/Kaizen-for-Operational-Excellence-at-ISP.jpg",
    companyName: "Kaizen for Operational Excellence at ISP",
  },

  // {
  //   id: 13,
  //   img: "https://i.ibb.co/fzFmn5JH/Operational-Excellence-and-Process-Re-Engineering-at-Magnum-Steel.jpg",
  //   companyName:
  //     "Operational Excellence and Process Re-Engineering at Magnum Steel",
  // },
  {
    id: 13,
    img: "https://i.ibb.co/QjFVkXvd/Lean-Factory-Design-and-Shop-Floor-Kaizen-in-progress-at-a-Steel-Fabrication-Plant-at-Confidence-Gro.jpg",
    companyName:
      "Lean Factory Design and Shop Floor Kaizen in progress at a Steel Fabrication Plant at Confidence Group",
  },
  {
    id: 7,
    img: "https://i.ibb.co/HfdTRqzD/Gemba-Walk-with-Team-at-Confidence-Infrastructure-Limited.jpg",
    companyName: "Gemba Walk with Team at Confidence Infrastructure Limited",
  },
  {
    id: 14,
    img: "https://i.ibb.co/ynYVQLyr/Operational-Excellence-Through-Sustainable-Efficiency-Employee-Development-SEED-Program-at-Fortune.jpg",
    companyName:
      "Operational Excellence Through Sustainable Efficiency & Employee Development (SEED) Program at Fortune",
  },
  {
    id: 15,
    img: "https://i.ibb.co/kVJRrhCw/488862781-2114011179073437-5159198807243872101-n.jpg",
    companyName:
      "Gemba Meeting with Shop Floor Operator during Lean Implementation at a Steel Fabrication Plant",
  },
  {
    id: 16,
    img: "https://i.ibb.co/p6Y0WJPh/Lean-Six-Sigma-Operational-Excellence-Training-at-DBL-Pharma.jpg",
    companyName:
      "Lean Six Sigma & Operational Excellence Training at DBL Pharma",
  },
  {
    id: 17,
    img: "https://i.ibb.co/nMCVMfMR/Lean-Implementation-Consulting-at-Apex-Footwar.jpg",
    companyName: "Lean Implementation Consulting at Apex Footwar",
  },
  {
    id: 18,
    img: "https://i.ibb.co/BVL3gsKy/Lean-Transfation-Consulting-at-a-Steel-Hardware-Factory.jpg",
    companyName: "Lean Transfation Consulting at a Steel Hardware Factory",
  },
  {
    id: 19,
    img: "https://i.ibb.co/qL5thVHV/Operational-Excellence-at-Confidence-Group.jpg",
    companyName: "Operational Excellence at Confidence Group",
  },
  {
    id: 20,
    img: "https://i.ibb.co/bggJ0HCX/Lean-Transformation-at-SPC-Pole-Manufacturing-Plant.jpg",
    companyName: "Lean Transformation at SPC Pole Manufacturing Plant",
  },
  {
    id: 21,
    img: "https://i.ibb.co/LzrjXQmd/Consulting-Morning-Meating-at-a-Heavy-Industry-Plant.jpg",
    companyName: "Consulting- Morning Meeting at a Heavy Industry Plant",
  },
  {
    id: 22,
    img: "https://i.ibb.co/DfD1rnt4/Lean-Implementation-at-a-Steel-Manufacturing-Plant.jpg",
    companyName: "Lean Implementation at a Steel Manufacturing Plant",
  },
  // {
  //   id: 22,
  //   img: "https://i.ibb.co/S46sxLS5/l-o-22.jpg",
  // },
  // {
  //   id: 23,
  //   img: "https://i.ibb.co/9HDF2RJ9/l-o-23.jpg",
  // },
  // {
  //   id: 24,
  //   img: "https://i.ibb.co/Gfcy10BR/l-o-24.jpg",
  // },
  // {
  //   id: 25,
  //   img: "https://i.ibb.co/9mrKRHx9/l-o-25.jpg",
  // },
  // {
  //   id: 26,
  //   img: "https://i.ibb.co/Z64S8sLg/l-o-26.jpg",
  // },
  // {
  //   id: 27,
  //   img: "https://i.ibb.co/QF5F7rkx/l-o-27.jpg",
  // },
  // // {
  // //   id: 28,
  // //   img: "https://i.ibb.co/7dvsP3gg/l-o-28.jpg",
  // // },
  // {
  //   id: 29,
  //   img: "https://i.ibb.co/d03GkCkK/l-o-29.jpg",
  // },
  // {
  //   id: 30,
  //   img: "https://i.ibb.co/FqC5CDCd/l-o-30.jpg",
  // },
  // {
  //   id: 31,
  //   img: "https://i.ibb.co/Ps5zjWwh/l-o-31.jpg",
  // },
  // {
  //   id: 32,
  //   img: "https://i.ibb.co/23GGBmR5/l-o-32.jpg",
  // },
  // {
  //   id: 33,
  //   img: "https://i.ibb.co/VWMD6kVH/l-o-33.jpg",
  // },
  // {
  //   id: 34,
  //   img: "https://i.ibb.co/d03GkCkK/l-o-34.jpg",
  // },
  // {
  //   id: 35,
  //   img: "https://i.ibb.co/k62wvb4X/l-o-35.jpg",
  // },
  // {
  //   id: 36,
  //   img: "https://i.ibb.co/wNs0VTr8/l-o-36.jpg",
  // },
];

export default leanOperational;
